import {Action} from "redux";

import {S3ConnectionSettings} from "../../models";

export enum S3ConnectionActionTypes {
  TEST_S3_CONNECTION_REQUEST = 's3Connection/s3_connection_test_request',
  TEST_S3_CONNECTION_SUCCESS = 's3Connection/s3_connection_test_success',
  TEST_S3_CONNECTION_FAILURE = 's3Connection/s3_connection_test_failure',
}

// Interfaces

export interface TestS3ConnectionRequestAction extends Action {
  type: S3ConnectionActionTypes.TEST_S3_CONNECTION_REQUEST;
  payload: {
    S3ConnectionSettings: S3ConnectionSettings;
  }
}

export interface TestS3ConnectionSuccessAction extends Action {
  type: S3ConnectionActionTypes.TEST_S3_CONNECTION_SUCCESS;
}

export interface TestS3ConnectionFailureAction extends Action {
  type: S3ConnectionActionTypes.TEST_S3_CONNECTION_FAILURE;
}

// Functions

export function testS3ConnectionRequest(S3ConnectionSettings: S3ConnectionSettings): TestS3ConnectionRequestAction {
  return {
    type: S3ConnectionActionTypes.TEST_S3_CONNECTION_REQUEST,
    payload: {
      S3ConnectionSettings
    }
  };
}

export function testS3ConnectionSuccess(): TestS3ConnectionSuccessAction {
  return {
    type: S3ConnectionActionTypes.TEST_S3_CONNECTION_SUCCESS,
  };
}

export function testS3ConnectionFailure(): TestS3ConnectionFailureAction {
  return {
    type: S3ConnectionActionTypes.TEST_S3_CONNECTION_FAILURE,
  };
}

export type S3ConnectionActions =
  TestS3ConnectionRequestAction |
  TestS3ConnectionSuccessAction |
  TestS3ConnectionFailureAction;
